import { render, staticRenderFns } from "./BarcodePopup.vue?vue&type=template&id=38394e22&"
import script from "./BarcodePopup.vue?vue&type=script&lang=js&"
export * from "./BarcodePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports